import { CircularProgress, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const MESSAGE_COUNT = 6;
const MESSAGE_CHANGE_INTERVAL = 30000;

const AvailabilitySearchLoading = () => {
  const [messageIndex, setMessageIndex] = useState(0);
  const { t } = useTranslation();

  useEffect(() => {
    const interval = window.setInterval(() => {
      setMessageIndex((current) => (current + 1) % MESSAGE_COUNT);
    }, MESSAGE_CHANGE_INTERVAL);

    return () => window.clearInterval(interval);
  }, []);

  return (
    <Stack alignItems="center" gap={2} sx={{ py: 8 }}>
      <CircularProgress />
      <Typography textAlign="center">
        {t(
          `page.schedules.newSchedule.schedule.bot.loadingMessages.${messageIndex}`,
        )}
      </Typography>
    </Stack>
  );
};

export default AvailabilitySearchLoading;
